enum HelpCenterLink {
  CampaignGuidelines = "https://help.formfunction.xyz/en/articles/6925872-campaigns-guidelines",
}

export default HelpCenterLink;
